import type { UseQueryResult } from "@edreamsodigeo/frontend-api-client";
import { useQuery } from "@edreamsodigeo/frontend-api-client";

import type {
  GetPriceBreakdownTotalPriceQuery,
  GetPriceBreakdownTotalPriceQueryVariables,
} from "~/generated/graphql";
import { PRICE_BREAKDOWN_TOTAL_PRICE } from "../providers/operations/priceBreakdownTotalPrice";
import { useShoppingInfo } from "./useShoppingInfo";
import { useFeeSelected } from "~/clientState/hooks/useFeeSelected";
import useGetPriceBreakDownPage from "~/clientState/hooks/useGetPriceBreakDownPage";

const usePricebreakDownTotalPriceQuery = (
  isPrimePriceSelected?: boolean,
): UseQueryResult<
  GetPriceBreakdownTotalPriceQuery,
  GetPriceBreakdownTotalPriceQueryVariables
> => {
  const shoppingInfo = useShoppingInfo();
  const { feeSelected } = useFeeSelected(isPrimePriceSelected);
  const requestPage = useGetPriceBreakDownPage();

  return useQuery<
    GetPriceBreakdownTotalPriceQuery,
    GetPriceBreakdownTotalPriceQueryVariables
  >(PRICE_BREAKDOWN_TOTAL_PRICE, {
    variables: {
      request: {
        shoppingInfo,
        feeSelected,
        requestPage,
      },
    },
    notifyOnBackgroundFetching: true,
  });
};

export default usePricebreakDownTotalPriceQuery;
